import React, { useState } from 'react';
import EmailForm from './LoginRecovery';
import OTPForm from './OTPForm';
import ResetPasswordForm from './ResetPasswordForm';
import itx from '../../assets/itx.png';
import '../../css/LoginRecovery.css';


const PasswordRecoveryWizard = () => {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState('');
  const [newPassword, setNewPassword] = useState('');

  const handleEmailNext = (userEmail) => {
    setEmail(userEmail);
    setStep(step + 1);
  };

  const handleOTPNext = () => {
    setStep(step + 1);
  };

  const handleResetPassword = (password) => {
    // Implement password reset logic (e.g., API call)
    alert(`Password reset successful. New password: ${password}`);
  };

  return (
    <div className='password-recovery-back'>
        <div className='password-recovery-container'>
            
            {step === 1 && <EmailForm onNext={handleEmailNext} />}
            {step === 2 && <OTPForm onNext={handleOTPNext} email={email} />}
            {step === 3 && <ResetPasswordForm onResetPassword={handleResetPassword} />}
        </div>
        <div className="footer">
        <img src={itx} alt="footer" />
      </div>
      
    </div>
  );
};

export default PasswordRecoveryWizard;
